import * as React from "react";

import * as AccordionPrimitive from "@radix-ui/react-accordion";

const AccordionRoot = AccordionPrimitive.Root;
export { AccordionRoot };
